//Константы из SetupView
export default {
  list: {
    loading: "Загрузка списка..."
  },
  loading: "Загрузка списка...",
  create: "Создать:",
  clear: "Очистить",
  confirm: {
    first: "Внимание!\nБудут удалены все настроенные представления для этого актива!",
    second: "ВНИМАНИЕ!\nВСЕ настроенные для этого актива представления будут удалены!"
  },
  tabs: {
    table: "Списки и Таблицы",
    tree: "Деревья",
    env: "Окружение",
    graph: "Графы",
    html: "Другие представления",
    cmp: "Сравнения",
    exporter: "Экспортёр",
    all: "Все представления"
  }
}
